import { useEffect, useState, useContext } from "react";
import Select from "react-select";
import axios from "axios";
import useAxios from "../../services/useAxios";
import {
  CustomInput,
  CustomTextArea,
} from "../../components/kits/inputs/Input";
import CustomButton from "../../components/kits/custom-button/CustomButton";
import "./Add.scss";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import { mobileChecker } from "../../utilities/regexCheckers";
import MapIR from "../../components/address/MapIR";

export default function Add({ setHeight, setIsOpen2, setUpdaterAddress }) {
  const [isOpen, setIsOpen] = useState(false);
  const [isOpenBtn, setIsOpenBtn] = useState(false);

  const [address, setAddress] = useState("");
  const [location, setLocation] = useState({
    lngLat: { lng: 54.42787580000132, lat: 36.84725311840381 },
  });
  const [options, setOptions] = useState([]);
  const auth = useContext(AuthenticationContext);
  const [step, setStep] = useState(1);
  const [Nextstep, setNextstep] = useState(true);
  const [menu, setMenu] = useState(false);
  const [selectedOption, setSelectedOption] = useState([]);

  const { execute: AddAddressApi } = useAxios("api/Insert_UsersAddress");

  const updateAddress = () => {
    setUpdaterAddress((prev) => !prev);
  };

  const inputValue = (newValue, actionMeta) => {
    if (newValue != "") {
      setMenu(true);
      axios({
        method: "post",
        url: "https://map.ir/search/v2/autocomplete",
        headers: {
          "Content-Type": "application/json",
          "x-api-key":
            "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImUwZGQ0MmEwNTVjNTcwNGI3ZTU4MmI2OTc3NzY1MzM2NjEwMjllZDM2MzBlOTk0MDkzYzBhOWUzNDIzMzZkNmQwM2YxMjBmMDJjMmI3ZjExIn0.eyJhdWQiOiIyMDA0NSIsImp0aSI6ImUwZGQ0MmEwNTVjNTcwNGI3ZTU4MmI2OTc3NzY1MzM2NjEwMjllZDM2MzBlOTk0MDkzYzBhOWUzNDIzMzZkNmQwM2YxMjBmMDJjMmI3ZjExIiwiaWF0IjoxNjY4ODA4MTMwLCJuYmYiOjE2Njg4MDgxMzAsImV4cCI6MTY3MTMxMzczMCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.SIGOXjwWMvLEj67F6uWpNoUTd3FAuZTDvdnnqM7JPs4263jHk--mMNKsKlHYWdIr3QRhP3hdiDgeVe4n9t3CSN5K4i2O1IsRA9W1sicHzIvpX8kO-fBNXLExS62EMS_gHLWWVNsfDPC8oCdmsNeR-tdukoy5w3EK2DLtp34kB4upyYruH3gTaZVntSYh3e6gD4j5AkuU3thNL4H0YdLWEQDtniIsn9_BVwv9Sxmf4E-3ZFh-VJSmmqCRdvAZ0h3iEHsBNrJJ4NUZT6-hEanLop8evr8xBhTlCgl4vDZVJ2ctdakZaqXm1Nojrv2VXWSZI4kYotteyj8I2sf-GlE7JA",
        },
        data: {
          text: `${newValue}`,
          $select: "roads,poi",
          $filter: "city eq گرگان",
        },
      }).then(({ data }) => {
        let array = [];
        data.value.map((item) => {
          array.push({
            label: item.address,
            value: `${item.geom.coordinates[0]}-${item.geom.coordinates[1]}`,
          });
        });

        setOptions(array);
      });
    } else {
      setMenu(false);
    }
  };

  async function AdAddressFunc(AddressData, TitleData, MobileData) {
    await AddAddressApi({
      title: TitleData,
      address: AddressData,
      mobile: MobileData,
      user_id: auth.userInfo.id,
      lang: location.lngLat.lng,
      lat: location.lngLat.lat,
    }).then((res) => {
      if (res.status == 1) {
        setIsOpen2(false);
        auth.refreshAddresses();
      }
    });
  }

  if (step == 1) {
    return (
      <>
        <div className="text-start mr-t-20 mr-b-16">
          <p className="title-h3-b ">افزودن آدرس</p>
        </div>
        <div className="">
          <div
            className="pd-x-4"
            style={{ position: "relative", zIndex: "11" }}
          >
            <Select
              menuIsOpen={menu}
              filterOption={() => true}
              onInputChange={(newValue, actionMeta) =>
                inputValue(newValue, actionMeta)
              }
              placeholder="جستجو محله در گرگان"
              className="my-3 desc-c-l"
              value={selectedOption}
              input={{ zIndex: "1000" }}
              options={options}
              onChange={(e) => {
                let dataArray = e.value.split("-");

                setLocation({
                  lngLat: { lng: dataArray[0], lat: dataArray[1] },
                });
                setAddress(e.label);
                setSelectedOption(e);
              }}
            />
          </div>
          <div className="pd-x-4">
            <MapIR
              location={location}
              height={388}
              setAddress={setAddress}
              setLocation={setLocation}
              setNextstep={setNextstep}
            />
          </div>
          <div className=""></div>
        </div>
        <div
          className="d-flex justify-content-between  w-100 pd-x-4 pd-y-20"
          style={{ bottom: "5rem" }}
        >
          <CustomButton
            className="pd-x-16 w-100"
            buttonStyle="primary"
            state="default"
            size="large"
            isIcon="false"
            onClick={() => {
              if (!(location.lngLat.lng === 54.42787580000132) && Nextstep) {
                setStep(2);
              }
            }}
          >
            <span className="title-h4-m">ادامه</span>
          </CustomButton>
        </div>
      </>
    );
  } else if (step == 2) {
    return (
      <>
        <div className="text-start pd-t-20 pd-b-16">
          <p className="title-h3-b">افزودن آدرس</p>
        </div>
        <div className="pd-x-4 mb-2 position-relative">
          {location && <MapIR location={location} height={150} />}

          <CustomButton
            className=""
            style={{
              width: 120,
              height: 32,
              position: "absolute",
              bottom: "5px",
              zIndex: "100",
            }}
            buttonStyle="primary"
            state="default"
            size="large"
            isIcon="false"
            onClick={() => {
              setSelectedOption({
                lngLat: { lng: 54.42787580000132, lat: 36.84725311840381 },
              });
              setStep(1);
            }}
          >
            <span className="title-h5-m pd-x-4"> ویرایش آدرس</span>
          </CustomButton>
        </div>

        <AllInputs
          setIsOpen2={setIsOpen2}
          address={address}
          AdAddressFunc={AdAddressFunc}
        />
      </>
    );
  }
}

const AllInputs = ({ AdAddressFunc, address, setIsOpen2 }) => {
  const [addressData, setAddressData] = useState("");
  const [titleData, setTitleData] = useState("");
  const [mobileData, setMobileData] = useState("");
  const [addressError, setAddressError] = useState("");
  const [titleError, setTitleError] = useState("");
  const [mobileError, setMobileError] = useState("");

  const valid = () => {
    let error = [1, 1, 1];
    if (addressData == "" && address == "") {
      setAddressError(" آدرس را وارد کنید.");
      error[0] = 0;
    } else {
      setAddressError("");
      error[0] = 1;
    }
    if (titleData == "") {
      setTitleError("عنوان آدرس را وارد کنید.");
      error[1] = 0;
    } else {
      setTitleError("");
      error[1] = 1;
    }
    if (mobileData == "") {
      setMobileError(" شماره تماس را وارد کنید.");
      error[2] = 0;
    } else if (!mobileChecker(mobileData)) {
      setMobileError(" شماره تماس وارد شده صحیح نیست.");
      error[2] = 0;
    } else {
      setMobileError("");
      error[2] = 1;
    }
    return error;
  };

  function toEnDigit(s) {
    return s.replace(
      /[\u0660-\u0669\u06f0-\u06f9]/g, // Detect all Persian/Arabic Digit in range of their Unicode with a global RegEx character set
      function (a) {
        return a.charCodeAt(0) & 0xf;
      } // Remove the Unicode base(2) range that not match
    );
  }

  return (
    <>
      <div className="mr-t-32">
        <CustomTextArea
          title="نشانی"
          placeholder="آدرس دقیق را اینجا وارد کنید."
          value={address.length > 0 ? address + "،" + addressData : addressData}
          onChange={(e) => {
            if (
              (!(e.target.value == address) || address.length == 0) &&
              e.target.value.split(address + "،").length != 1
            ) {
              setAddressData(e.target.value.replace(address + "،", ""));
            }
          }}
          messageText={addressError}
          containerClassName="mr-b-32"
          labelClassName="pd-b-4"
          textType={addressError.length === 0 ? "none" : "error"}
        />
        <CustomInput
          title="عنوان آدرس"
          placeholder="مثال: محل کار"
          value={titleData}
          onChange={(e) => {
            setTitleData(e.target.value);
          }}
          messageText={titleError}
          containerClassName="mr-b-32"
          labelClassName="pd-b-4"
          textType={titleError.length === 0 ? "none" : "error"}
        />
        <CustomInput
          title="شماره تماس"
          placeholder="۰۹xx xxx xx xx"
          value={mobileData}
          onChange={(e) => {
            setMobileData(toEnDigit(e.target.value));
          }}
          messageText={mobileError}
          containerClassName="mr-b-32"
          labelClassName="pd-b-4"
          textType={mobileError.length === 0 ? "none" : "error"}
        />
      </div>
      <div className="d-flex justify-content-between  w-100 pd-x-20 mr-b-20">
        <CustomButton
          className="w-50"
          buttonStyle=""
          state="default"
          size="medium"
          isIcon="false"
          onClick={() => {
            setIsOpen2(false);
          }}
        >
          <span className="title-h4-m">انصراف</span>
        </CustomButton>
        <CustomButton
          className="w-50"
          buttonStyle="primary"
          state="default"
          size="medium"
          isIcon="false"
          onClick={() => {
            let error = valid();
            if (error[0] && error[1] && error[2]) {
              AdAddressFunc(address + "&" + addressData, titleData, mobileData);
            }
          }}
        >
          <span className="title-h4-m">افزودن</span>
        </CustomButton>
      </div>
    </>
  );
};
